import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
} from "@mui/material";
import { Formik } from "formik";
import { useState } from "react";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";

import BasicInformationService from "../../../../../infrastructure/api/basicInformation";
import { wrapFormikHandleChange } from "../../../../../infrastructure/utils/formatters";
import ProvinceSelect from "../../../../components/base-information/ProvinceSelect";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";

const validationSchema = Yup.object().shape({
  cityName: Yup.string().required("لطفا این فیلد را پر کنید."),
  provinceId: Yup.number().required("لطفا این فیلد را پر کنید."), 
   
  isActive: Yup.bool(),
});

const CityInformationModifyPage = () => {
  const data = useLoaderData("root");
  let navigate = useNavigate();
  const { id: roleId } = useParams();

  const [loading, setLoading] = useState(false);

  const onNavigateToListPage = () => {
    navigate("/BI/Grid/CityInformation");
  };

  // Submit Action
  const onSubmit = async (formValue, { setSubmitting }) => {
    setLoading(true);
    const sendData = { ...data, ...formValue };

    try {
      const res = await BasicInformationService.modifyCityInformationApi(
        sendData
      );

      if (res.isSuccess) {
        toast.success(res.message);
        onNavigateToListPage();
      } else {
        toast.error(res.message);
      }

      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطایی رخ داده است.");

      setLoading(false);
      setSubmitting(false);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={
              roleId !== "create" ? `ویرایش ${data?.city?.cityName}` : "ایجاد"
            }
          />

          <CardContent>
            <Formik
              initialValues={data.city}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => (
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6} lg={4}>
                      <TextField
                        label="نام شهرستان"
                        variant="outlined"
                        fullWidth
                        name="cityName"
                        type="cityName"
                        value={values.cityName}
                        onChange={wrapFormikHandleChange(handleChange)}
                        error={errors.cityName && touched.cityName}
                        helperText={
                          errors.cityName && touched.cityName && errors.cityName
                        }
                      />
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                      <ProvinceSelect
                        label="استان"
                        value={values.provinceId}
                        onChange={(event) => {
                          setFieldValue("provinceId", event.target.value);
                        }}
                        provinceList={data.provinceList}
                        error={errors.provinceId && touched.provinceId}
                        helperText={
                          errors.provinceId &&
                          touched.provinceId &&
                          errors.provinceId
                        }
                      />
                    </Grid>

                     
 

                    <Grid item xs={12} md={6} lg={4}>
                      <FormControlLabel
                        name="isActive"
                        value={values.isActive}
                        checked={values.isActive}
                        onChange={wrapFormikHandleChange(handleChange)}
                        control={<Switch />}
                        label="فعال"
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={12}
                      container
                      justifyContent={"flex-end"}
                    >
                      <Button
                        disabled={isSubmitting}
                        variant="outlined"
                        size="large"
                        color="gray"
                        sx={{ mx: 1 }}
                        onClick={onNavigateToListPage}
                      >
                        انصراف
                      </Button>

                      <Button
                        disabled={isSubmitting}
                        variant="contained"
                        type="submit"
                        size="large"
                      >
                        {loading && (
                          <CircularProgress size={16} color="inherit" />
                        )}
                        {roleId !== "create" ? "ویرایش" : "ایجاد"}
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            </Formik>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CityInformationModifyPage;
